import React from 'react';
import { Gift } from 'lucide-react';
import { useLanguage } from '../../contexts/useLanguage';

type Props = {
  /** Extra classes for the outer wrapper */
  className?: string;
};

/**
 * Friendly empty state when a public web catalog section has no products yet
 * (replaces generic “no results” copy).
 */
export function WebCatalogUpdatingNotice({ className = '' }: Props) {
  const { t } = useLanguage();
  return (
    <div
      className={`rounded-2xl border border-[#e5d9ce] bg-white/90 px-6 py-12 text-center shadow-sm ${className}`.trim()}
      role="status"
      aria-live="polite"
    >
      <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-[#f0e6dc]">
        <Gift className="h-7 w-7 text-[#6b5344]" aria-hidden />
      </div>
      <h3
        className="mb-2 text-lg font-semibold text-[#3d2817]"
        style={{ fontFamily: 'var(--webdesigned-ui-font, ui-sans-serif, system-ui, sans-serif)' }}
      >
        {t('common.catalogUpdatingTitle')}
      </h3>
      <p className="mx-auto max-w-md text-sm leading-relaxed text-[#5d4437]">{t('common.catalogUpdatingBody')}</p>
    </div>
  );
}
